import { Menu } from './menu.model';

export const verticalMenuItems = [
  new Menu(1, 'Dashboard', '/dashboard', null, 'dashboard', null, false, 0),

    new Menu(2, 'Staff Management', '', null, 'supervisor_account', null, true, 0),
      new Menu(202, 'Role', '/master/role', null, 'group', null, false, 2),
    new Menu(201, 'Staff', '/master/users', null, 'person', null, false, 2),
  
 new Menu(204, 'Service Provider', '/master/service_provider', null, 'support_agent', null, false, 2),


    new Menu(3, 'Service Management', '', null, 'build_circle', null, true, 0),
    new Menu(302, 'Service Type', '/master/ServiceTypes', null, 'view_list', null, false, 3),
    new Menu(301, 'Service Category', '/master/Service-Category', null, 'category', null, false, 3),
       

    new Menu(304, 'Service', '/master/service', null, 'home_repair_service', null, false, 3),
     new Menu(308, 'Mapping Of Services', '/master/mappingofserviceprovider', null, 'map', null, false, 3),

    new Menu(4, 'Offer Management', '', null, 'card_giftcard', null, true, 0),
    new Menu(401, 'Offer Category', '/master/offer-category', null, 'category', null, false, 4),
    // new Menu(402, 'Offers', '/master/offer-list', null, 'local_offer', null, false, 4),
    new Menu(403, 'Add Discount Offers', '/master/AddDiscountOfferList', null, 'discount', null, false, 4),
    new Menu(404, 'Rewards', '/master/rewards', null, 'emoji_events', null, false, 4),

    new Menu(8, 'Advertise Management', '', null, 'campaign', null, true, 0),

    new Menu(801, 'Advertise', '/master/advertise', null, 'ads_click', null, false, 8),
    new Menu(6, 'Customer Management', '', null, 'manage_accounts', null, true, 0),

new Menu(601, 'Customer List', '/master/customer_list', null, 'person_search', null, false, 6),
new Menu(604, 'Customer Orders', '/master/order_list', null, 'shopping_bag', null, false, 6),

// new Menu(602, 'Customer History', '/master/customer_history', null, 'history', null, false, 6),

new Menu(603, 'Customer Feedback', '/master/customer_feedback', null, 'feedback', null, false, 6),
new Menu(605, 'Complaint Management', '/master/complaints', null, 'report_problem', null, false, 6),
new Menu(602, 'Customer History', '/master/customer_history', null, 'history', null, false, 6),

    new Menu(9, 'Reports', '', null, 'assessment', null, true, 0),
    new Menu(901, 'Wallet History', '/report/wallet-history', null, 'account_balance_wallet', null, false, 9),
    new Menu(902, 'Transaction History', '/report/transaction-history', null, 'receipt_long', null, false, 9),

    new Menu(5, 'Integrated Video', '/master/video', null, 'videocam', null, false, 0),

    // new Menu(2, 'Master', '', null, 'supervisor_account', null, true, 0),
    
    // new Menu(4, 'T & C', '/master/terms-and-condition', null, 'assignment', null, false, 2),
    // new Menu(201, 'Users', '/master/users-new', null, 'account_circle', null, false, 2),
    // new Menu(203, 'Warehouse', '/master/warehouse', null, 'groupsupervised_user_circle', null, false, 2),

    // new Menu(302, 'Brand', '/master/brand', null, 'groupsupervised_user_circle', null, false, 3),
    // new Menu(303, 'UOM', '/master/uom', null, '123', null, false, 3),
    // new Menu(305, 'Base Package Product', '/master/Statewiseproduct', null, 'view_carousel', null, false, 3),
    // new Menu(306, 'Base Product Size', '/master/baseProductSize', null, 'view_carousel', null, false, 3),
    // new Menu(307, 'Opening Stock', '/master/opening-stock', null, 'view_carousel', null, false, 3),
    
    // new Menu(304, 'Price', '/users', null, '123', null, false, 3),



    // new Menu(7, 'Kit BOM', '', null, 'card_giftcard', null, true, 0),
    // new Menu(701, 'Add Kit BOM', '/master/generateKit', null, 'list', null, false,7),
    // new Menu(702, 'Add Kit BOM QTY', '/master/addKitQty', null, 'card_giftcard', null, false, 7),
    

    // new Menu(6, 'Crop Management', '', null, 'local_florist', null, true, 0),
    // new Menu(601, 'Crop Category', '/master/crop-category', null, 'local_florist', null, false, 6),
    // new Menu(602, 'Crop', '/master/crop', null, 'local_florist', null, false, 6),
    
    
    
    
    // new Menu(203, 'BOQ', '/master/userscopy', null, 'supervisor_account', null, false, 0),
    
    // new Menu(5, 'Report', '', null, 'list', null, true, 0),
    //new Menu(6, 'Warehouse Stock Report', '/report/Warehouse-Stock-Report', null, 'list', null, false, 5),
    // new Menu(6, 'Warehouse Stock Grid', '/report/Warehouse-Stock-Grid', null, 'list', null, false, 5),
    // new Menu(6, 'Stock Transaction Report', '/report/stock-transaction-Report', null, 'list', null, false, 5),
   

  // new Menu(43, 'Login', '/login', null, 'exit_to_app', null, false, 40),
  //   new Menu(44, 'Register', '/register', null, 'person_add', null, false, 40),
  //   new Menu(45, 'Blank', '/blank', null, 'check_box_outline_blank', null, false, 40),
  //   new Menu(46, 'Page Not Found', '/pagenotfound', null, 'error_outline', null, false, 40),
  //   new Menu(47, 'Error', '/error', null, 'warning', null, false, 40),
  //   new Menu(48, 'Search', '/search', null, 'search', null, false, 40),
  //   new Menu(49, 'Landing', '/landing', null, 'filter', null, false, 40),
  //   new Menu(50, 'Profile', null, null, 'person', null, true, 40),
  //   new Menu(51, 'Projects', '/profile/projects', null, 'note', null, false, 50),
  //   new Menu(52, 'User Info', '/profile/user-info', null, 'perm_contact_calendar', null, false, 50),
    //new Menu(200, 'External Link', null, 'http://themeseason.com', 'open_in_new', '_blank', false, 0)
]

export const horizontalMenuItems = [
    new Menu(1, 'Dashboard', '/', null, 'dashboard', null, false, 0),
    new Menu(2, 'Users', '/users', null, 'supervisor_account', null, false, 0),
    new Menu(3, 'Product Category', '/users', null, 'supervisor_account', null, false, 0),
    new Menu(4, 'Products', '/users', null, 'supervisor_account', null, false, 0),
    // new Menu(3, 'UI Features', null, null, 'computer', null, true, 0),
    // new Menu(4, 'Buttons', '/ui/buttons', null, 'keyboard', null, false, 3),
    // new Menu(5, 'Cards', '/ui/cards', null, 'card_membership', null, false, 3),
    // new Menu(6, 'Lists', '/ui/lists', null, 'list', null, false, 3),
    // new Menu(7, 'Grids', '/ui/grids', null, 'grid_on', null, false, 3),
    // new Menu(8, 'Tabs', '/ui/tabs', null, 'tab', null, false, 3),
    // new Menu(9, 'Expansion Panel', '/ui/expansion-panel', null, 'dns', null, false, 3),
    // new Menu(10, 'Chips', '/ui/chips', null, 'label', null, false, 3),
    // new Menu(11, 'Progress', '/ui/progress', null, 'data_usage', null, false, 3),
    // new Menu(12, 'Dialog', '/ui/dialog', null, 'open_in_new', null, false, 3),
    // new Menu(13, 'Tooltip', '/ui/tooltip', null, 'chat_bubble', null, false, 3),
    // new Menu(14, 'Snackbar', '/ui/snack-bar', null, 'sms', null, false, 3),
    // new Menu(16, 'Mailbox', '/mailbox', null, 'email', null, false, 40),
    // new Menu(17, 'Chat', '/chat', null, 'chat', null, false, 40),
    // new Menu(20, 'Form Controls', null, null, 'dvr', null, true, 0),
    // new Menu(21, 'Autocomplete', '/form-controls/autocomplete', null, 'short_text', null, false, 20),
    // new Menu(22, 'Checkbox', '/form-controls/checkbox', null, 'check_box', null, false, 20),
    // new Menu(23, 'Datepicker', '/form-controls/datepicker', null, 'today', null, false, 20),
    // new Menu(24, 'Form field', '/form-controls/form-field', null, 'view_stream', null, false, 20),
    // new Menu(25, 'Input', '/form-controls/input', null, 'input', null, false, 20),
    // new Menu(26, 'Radio button', '/form-controls/radio-button', null, 'radio_button_checked', null, false, 20),
    // new Menu(27, 'Select', '/form-controls/select', null, 'playlist_add_check', null, false, 20),
    // new Menu(28, 'Slider', '/form-controls/slider', null, 'tune', null, false, 20),
    // new Menu(29, 'Slide toggle', '/form-controls/slide-toggle', null, 'star_half', null, false, 20),
    // new Menu(30, 'Tables', null, null, 'view_module', null, true, 0),
    // new Menu(31, 'Basic', '/tables/basic', null, 'view_column', null, false, 30),
    // new Menu(32, 'Paging', '/tables/paging', null, 'last_page', null, false, 30),
    // new Menu(33, 'Sorting', '/tables/sorting', null, 'sort', null, false, 30),
    // new Menu(34, 'Filtering', '/tables/filtering', null, 'format_line_spacing', null, false, 30),
    // new Menu(35, 'Selecting', '/tables/selecting', null, 'playlist_add_check', null, false, 30),
    // new Menu(36, 'NGX DataTable', '/tables/ngx-table', null, 'view_array', null, false, 30),
    // new Menu(70, 'Charts', null, null, 'multiline_chart', null, true, 0),
    // new Menu(71, 'Bar Charts', '/charts/bar', null, 'insert_chart', null, false, 70),
    // new Menu(72, 'Pie Charts', '/charts/pie', null, 'pie_chart', null, false, 70),
    // new Menu(73, 'Line Charts', '/charts/line', null, 'show_chart', null, false, 70),
    // new Menu(74, 'Bubble Charts', '/charts/bubble', null, 'bubble_chart', null, false, 70),
    // new Menu(81, 'Drag & Drop', '/drag-drop', null, 'mouse', null, false, 3),
    // new Menu(85, 'Material Icons', '/icons', null, 'insert_emoticon', null, false, 3),
    // new Menu(40, 'Pages', null, null, 'library_books', null, true, 0),
    // new Menu(43, 'Login', '/login', null, 'exit_to_app', null, false, 40),
    // new Menu(44, 'Register', '/register', null, 'person_add', null, false, 40),
    // new Menu(45, 'Blank', '/blank', null, 'check_box_outline_blank', null, false, 40),
    // new Menu(46, 'Page Not Found', '/pagenotfound', null, 'error_outline', null, false, 40),
    // new Menu(47, 'Error', '/error', null, 'warning', null, false, 40),
    // new Menu(48, 'Search', '/search', null, 'search', null, false, 40),
    // new Menu(49, 'Landing', '/landing', null, 'filter', null, false, 40),
    // new Menu(50, 'Profile', null, null, 'person', null, true, 40),
    // new Menu(51, 'Projects', '/profile/projects', null, 'note', null, false, 50),
    // new Menu(52, 'User Info', '/profile/user-info', null, 'perm_contact_calendar', null, false, 50),
    // new Menu(55, 'Schedule', '/schedule', null, 'event_note', null, false, 40),
    // new Menu(200, 'External Link', null, 'http://themeseason.com', 'open_in_new', '_blank', false, 40),
    // new Menu(66, 'Maps', null, null, 'map', null, true, 0),
    // new Menu(67, 'Google', '/maps/googlemaps', null, 'location_on', null, false, 66),
    // new Menu(68, 'Leaflet', '/maps/leafletmaps', null, 'my_location', null, false, 66),
]